/*
 * Copyright (c) 2026. Slimme Infrasoftware B.V. Apeldoorn /
 * Spin in het Web B.V. Apeldoorn.
 * Deze software mag alleen gebruikt / bekeken / gewijzigd worden
 * volgens de voorwaarden die zijn vastgelegd in de overeenkomst
 * tussen ATR en Slimme Infrasoftware B.V. en de onderliggende
 * overeenkomsten tussen Slimme Infrasoftware B.V en
 * Spin in het Web B.V.
 */

/*
* project.ts
* 12-2-2021 - Jelmer Jellema - Spin in het Web B.V.
* Projectmodel
*/

//ATRPLAN

import {Basemodel, ModelField, ModelRelation} from './basemodel';
import {hash} from '../app/types';
import {ProjectFunctie} from './project_functie';
import moment from 'moment';
import {Planitem} from './planitem';

export class Project extends Basemodel {
  static table = 'project';
  static defaultOrder = ['omschrijving'];

  @ModelField() override id: number = null;
  @ModelField() naam: string;
  @ModelField() klantnaam: string;
  @ModelField() omschrijving: string;
  @ModelField() werkmaatschappij_id: number;
  @ModelField() begindatum: string = moment().startOf('month').format('YYYY-MM-DD');
  @ModelField() einddatum: string = null; //yyyy-mm-dd
  @ModelField() elementnummer: string;
  @ModelField() locatie: string;
  @ModelField() werkorder: string;
  @ModelField() projectleider: string; //vooral voor exact
  @ModelField() uitvoerder_id: number;
  @ModelField() werkvoorbereider_id: number;
  @ModelField() opmerkingen: string;
  @ModelField() kleur: string;
  @ModelField() exact_id: string = null;
  @ModelField() factureerbaar: boolean = true; //is dit project factureerbaar?
  @ModelField() externe_werkmaatschappij: number = null; //id van een externe werkmaatschappij. Als dit gegeven is, toont dit project de diensten die wij mogen invullen, en schrijven we werkbonnen op dit project

  @ModelRelation({model: ProjectFunctie}) project_functie: ProjectFunctie[] = [];
  @ModelRelation({model: Planitem}) planitem: Planitem[] = [];

  /**
   * Maak een goede omschrijving obv omschrijving uit exact en code uit exact (naam)
   */
  get label(): string {
    if (this.omschrijving?.length) {
      return `${this.omschrijving} (${this.naam})`;
    }
    else
    {
      return this.naam;
    }
  }

  get labelMetKlant(): string {
    let label = this.label;
    if (this.klantnaam?.length) {
      label += ` (${this.klantnaam})`;
    }
    return label;
  }

  override get recordbeschrijving(): string {
    return this.omschrijving;
  }

  get numFuncties(): number {
    return this.project_functie?.length ?? 0;
  }

  //heeft functie?
  public heeftStandaardfunctie(functieId: number): boolean {
    return this.project_functie && this.project_functie.some(pf => pf.functie_id === functieId);
  }

  /**
   * Geef kritiek op de huidige indeling
   */
  protected override maakKritiek(): hash<string []> {
    let kritiek = {
      //categorieën
      functies: []
    }
    if (this.project_functie && (!this.project_functie.length)) {
      kritiek.functies.push('Dit project heeft geen standaardfuncties');
    }
    return kritiek;
  }

  public get bron(): 'Exact'|'ATRPlan' {
    return this.exact_id ? 'Exact' : 'ATRPlan';
  }
}
